export default __webpack_public_path__ + "static/media/passwordGenerator.b84b8c30.png";